<template>
  <div>
    <div class="customer_total" v-if="isLimit">
      <div class="customer_total_tab">
        <van-tabs class="tab_customer" v-model="activeName" @click="onClickTab">
          <van-tab name="all" title="全部"></van-tab>
          <van-tab name="mine" title="我的"></van-tab>
        </van-tabs>
      </div>
      <div class="customer_total_border">
        <div class="total_header">
          <div class="total_title">
            <H4>客户统计</H4>
            <div class="tab_day">
              <input type="radio" v-model="isSeven" id="left" value="left" />
              <label for="left">近7天</label>
              <input type="radio" v-model="isSeven" id="right" value="right" />
              <label for="right">近30天</label>
            </div>
          </div>
          <div class="item_customer">
            <div class="flex_total_item">
              <p>客户总数</p>
              <H4>{{ customerCount }}</H4>
            </div>
            <div class="flex_total_item">
              <p>新增客户数</p>
              <H4>{{ addCustomer }}</H4>
            </div>
            <div class="flex_total_item">
              <p>流失客户数</p>
              <H4>{{ lossCustomer }}</H4>
            </div>
          </div>
        </div>
        <div class="echarts_wrap">
          <div class="checkboxGroup">
            <van-checkbox-group v-model="checked" direction="horizontal" icon-size="15px">
              <van-checkbox name="customerTotal" checked-color="#277FFF">客户总数</van-checkbox>
              <van-checkbox name="addCustomer" checked-color="#11C690">新增客户</van-checkbox>
              <van-checkbox name="loseCustomer" checked-color="#F6B600">流失客户</van-checkbox>
            </van-checkbox-group>
          </div>
          <customer-chart :propData="behavior_data" :checkbox="checked" :isSeven="isSeven"></customer-chart>
        </div>
      </div>
    </div>
    <emptyPage :isLimit="isLimit" />
  </div>
</template>

<script>
import customerChart from "./customerChart.vue";
import { getCurrentCustomer } from "@/server/api.js";
import { Toast } from "vant";
import CustomerChart from "@/views/customer/customerChart";
import { wefunstatistics, pageLimit } from "@/utils/public";
import emptyPage from "@/components/emptyPage";
export default {
  name: "customerTotal",
  components: { CustomerChart, emptyPage },
  data() {
    return {
      checked: ["customerTotal", "addCustomer", "loseCustomer"],
      userIds: [],
      sevensDaySta: new Date(Date.now() - 24000 * 3600 * 7).toLocaleDateString().replace(/\//g, "-"),
      sevensDayEnd: new Date(Date.now() - 24000 * 3600).toLocaleDateString().replace(/\//g, "-"),
      monthDaySta: new Date(Date.now() - 24000 * 3600 * 30).toLocaleDateString().replace(/\//g, "-"),
      monthDayEnd: new Date(Date.now() - 24000 * 3600).toLocaleDateString().replace(/\//g, "-"),
      activeName: "all",
      startDate: "",
      endDate: "",
      isSeven: "left",
      customerCount: 0,
      addCustomer: 0,
      lossCustomer: 0,
      behavior_data: [],
      loading: "",
      userId: localStorage.getItem("userid"),
      isLimit: "",
    };
  },
  async created() {
    this.startDate = this.sevensDaySta;
    this.endDate = this.sevensDayEnd;
    let that = this;
    await pageLimit("customer:statistics:query", function (bool) {
      that.isLimit = bool;
    });
    if (this.isLimit) {
      await this.getCustomerData();
      await wefunstatistics("10", window.location.href.split("#")[0]);
    }
  },
  methods: {
    async getCustomerData() {
      let res = await getCurrentCustomer({
        userIds: this.userIds,
        startDate: this.startDate,
        endDate: this.endDate,
      });
      if (res.code !== "200") return Toast.fail(res.msg);
      this.customerCount = res.data.stu_cnt;
      this.addCustomer = res.data.new_contact_cnt;
      this.lossCustomer = res.data.negative_feedback_cnt;
      this.behavior_data = res.data.behavior_data;
      if (!this.behavior_data) return (this.behavior_data = []);
    },
    onClickTab(data) {
      console.log(data);
      this.activeName = data;
    },
  },
  watch: {
    activeName(val) {
      if (val == "all") {
        this.userIds = [];
        this.startDate = this.sevensDaySta;
        this.endDate = this.sevensDayEnd;
        this.checked = ["customerTotal", "addCustomer", "loseCustomer"];
        this.getCustomerData();
      } else {
        this.userIds = [this.userId];
        this.startDate = this.sevensDaySta;
        this.endDate = this.sevensDayEnd;
        this.checked = ["customerTotal", "addCustomer", "loseCustomer"];
        this.getCustomerData();
      }
      this.isSeven = "left";
    },
    isSeven(val) {
      console.log(val);
      if (val === "left") {
        this.startDate = this.sevensDaySta;
        this.endDate = this.sevensDayEnd;
        this.getCustomerData();
      } else {
        this.startDate = this.monthDaySta;
        this.endDate = this.monthDayEnd;
        this.getCustomerData();
      }
    },
  },
};
</script>

<style scoped lang="less">
.customer_total {
  min-height: 100%;
  background-color: #f6f6f6;
  .customer_total_tab {
    background-color: #ffffff;
    margin-bottom: 14px;
    .tab_customer {
      /deep/.van-tabs__wrap {
        height: 80px;
      }
      /deep/.van-tabs__line {
        width: 50px;
        height: 6px;
        background: linear-gradient(90deg, #4fb6ff 0%, #277fff 100%);
        border-radius: 3px;
      }
      /deep/.van-tab {
        height: 80px;
        line-height: 80px;
        color: #666666;
        font-size: 28px;
      }
      /deep/.van-tab--active {
        font-weight: 600;
        color: #333333 !important;
      }
    }
  }
  .customer_total_border {
    color: #333333;
    padding: 0 30px 20px;
    .total_header {
      background-color: #ffffff;
      border-radius: 14px;
      margin: 20px 0;
      padding: 48px 30px 50px;
      .total_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tab_day {
          position: relative;
          display: flex;
          align-items: center;
          input {
            display: none;
          }
          label {
            font-size: 26px;
            color: #333333;
            margin-left: 26px;
          }
          input:checked + label {
            color: #277fff;
          }
          &:before {
            content: "";
            position: absolute;
            height: 30px;
            width: 1px;
            background-color: #333333;
            right: 92px;
            top: 8px;
          }
        }
        h4 {
          font-size: 32px;
        }
      }
      .item_customer {
        display: flex;
        margin-top: 74px;
        padding: 0 10px 0 16px;
        justify-content: space-between;
        .flex_total_item {
          text-align: left;
          p {
            font-size: 28px;
            margin-bottom: 22px;
          }
          h4 {
            font-size: 36px;
          }
        }
      }
    }

    .echarts_wrap {
      height: 690px;
      background-color: #ffffff;
      border-radius: 14px;
      padding: 34px 30px 40px;
      .checkboxGroup {
        /deep/.van-checkbox--horizontal {
          padding-top: 2px;
        }
        /deep/ .van-checkbox__label {
          font-size: 26px;
          color: #333333;
        }
        /deep/.van-checkbox__icon {
          position: relative;
          top: -2px;
        }
      }
      .echarts_show {
        height: 590px;
      }
    }
  }
}
</style>
